import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Table, Card, Row, Col, Typography, Space, Button, Drawer } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
const { Text, Title } = Typography;
const ResponsiveTable = ({ columns, dataSource = [], mobileCardRender, mobileBreakpoint = 768, showMobileActions = true, mobileActionRender, ...tableProps }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [drawerVisible, setDrawerVisible] = useState(false);
    useEffect(() => {
        const checkIsMobile = () => {
            setIsMobile(window.innerWidth < mobileBreakpoint);
        };
        checkIsMobile();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, [mobileBreakpoint]);
    const handleViewDetails = (record) => {
        setSelectedRecord(record);
        setDrawerVisible(true);
    };
    const renderMobileCard = (record, index) => {
        if (mobileCardRender) {
            return mobileCardRender(record, index);
        }
        // Default mobile card rendering
        const visibleColumns = columns.filter(col => !col.responsive || col.responsive.includes('xs'));
        return (_jsx(Card, { style: {
                marginBottom: 12,
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }, styles: {
                body: { padding: 16 }
            }, actions: showMobileActions ? [
                _jsx(Button, { type: "text", icon: _jsx(EyeOutlined, {}), onClick: () => handleViewDetails(record), className: "touch-target", style: { color: "var(--ant-color-primary)" }, children: "Ver detalles" }, "view"),
                ...(mobileActionRender ? [mobileActionRender(record, index)] : [])
            ] : undefined, children: _jsx(Space, { direction: "vertical", size: 8, style: { width: '100%' }, children: visibleColumns.map((column, colIndex) => {
                    if (!column.dataIndex && !column.render)
                        return null;
                    const value = column.dataIndex
                        ? record[column.dataIndex]
                        : column.render
                            ? column.render(record[column.dataIndex] || '', record, index)
                            : '';
                    return (_jsxs(Row, { justify: "space-between", align: "middle", children: [_jsx(Col, { children: _jsx(Text, { type: "secondary", style: { fontSize: 12, fontWeight: 500 }, children: column.title }) }), _jsx(Col, { style: { textAlign: 'right', maxWidth: '60%' }, children: _jsx(Text, { style: { fontSize: 14, fontWeight: 500 }, children: value }) })] }, colIndex));
                }) }) }, record.key || index));
    };
    const renderMobileView = () => {
        return (_jsxs("div", { className: "responsive-table-mobile", children: [dataSource.map((record, index) => renderMobileCard(record, index)), _jsx(Drawer, { title: "Detalles", placement: "bottom", onClose: () => setDrawerVisible(false), open: drawerVisible, height: "80%", styles: {
                        body: { padding: 16 }
                    }, children: selectedRecord && (_jsx(Space, { direction: "vertical", size: 16, style: { width: '100%' }, children: columns.map((column, index) => {
                            if (!column.dataIndex && !column.render)
                                return null;
                            const value = column.dataIndex
                                ? selectedRecord[column.dataIndex]
                                : column.render
                                    ? column.render(selectedRecord[column.dataIndex] || '', selectedRecord, index)
                                    : '';
                            return (_jsxs("div", { style: {
                                    padding: 12,
                                    background: '#fafafa',
                                    borderRadius: 8
                                }, children: [_jsx(Text, { type: "secondary", style: {
                                            fontSize: 12,
                                            fontWeight: 500,
                                            display: 'block',
                                            marginBottom: 4,
                                        }, children: column.title }), _jsx(Text, { style: { fontSize: 14, fontWeight: 500 }, children: value })] }, index));
                        }) })) })] }));
    };
    const renderDesktopView = () => {
        return (_jsx("div", { className: "responsive-table-desktop", children: _jsx(Table, { ...tableProps, columns: columns, dataSource: dataSource, scroll: { x: 'max-content' }, style: {
                    background: '#ffffff',
                    borderRadius: 12,
                    overflow: 'hidden',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                } }) }));
    };
    return (_jsxs("div", { className: "responsive-table-container", children: [isMobile ? renderMobileView() : renderDesktopView(), _jsx("style", { children: `
        .responsive-table-container {
          width: 100%;
        }
        
        .responsive-table-mobile .ant-card-actions {
          background: #fafafa;
          border-radius: 0 0 12px 12px;
        }
        
        .responsive-table-mobile .ant-card-actions > li {
          margin: 8px 0;
        }
        
        .responsive-table-mobile .ant-card-actions > li > span {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 44px;
          border-radius: 8px;
          transition: all 0.3s ease;
        }
        
        .responsive-table-mobile .ant-card-actions > li > span:hover {
          background: rgba(24, 144, 255, 0.1);
          color:  var(--ant-color-primary);
        }
        
        .responsive-table-desktop .ant-table-thead > tr > th {
          background: #fafafa;
          font-weight: 600;
          padding: 16px;
        }
        
        .responsive-table-desktop .ant-table-tbody > tr > td {
          padding: 16px;
        }
        
        .responsive-table-desktop .ant-table-tbody > tr:hover > td {
          background: #f5f5f5;
        }
        
        @media (max-width: 767px) {
          .responsive-table-desktop {
            overflow-x: auto;
          }
          
          .responsive-table-desktop .ant-table {
            min-width: 600px;
          }
        }
        
        @media (hover: none) and (pointer: coarse) {
          .responsive-table-mobile .ant-card-actions > li > span:hover {
            background: transparent;
            color: inherit;
          }
        }
      ` })] }));
};
export default ResponsiveTable;
